import React from "react";
import Navbar from "../components/sub-comp/Navbar";
import Footer from "../components/sub-comp/MainFooter";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const StudentPortal = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <section className="py-16 bg-gradient-to-r from-custom-pink to-purple-800 text-white text-center">
        <h1 className="text-4xl font-bold">Student Portal</h1>
        <p className="mt-2 text-white/90">Access your student resources.</p>
      </section>
      <section className="container mx-auto px-4 py-12">
        <div className="bg-white rounded-xl shadow p-6 text-gray-800">
          <p>Portal integration coming soon.</p>
        </div>
      </section>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default StudentPortal;



